import { 
    FieldBtn
} from './../../../dues/dues.style';
import React, { useState } from 'react'
import {  Dialog, toaster } from 'evergreen-ui';
import {
    AppInputField,InputFieldTitleText, AppInputFieldBtnCancel, AppInputFieldBtn
} from './../../../../../../widget/styledComponents/input_field.style'
import { gql, useMutation } from '@apollo/client';
import Cookies from 'js-cookie';



export const EDIT_SUBADMIN = gql`
mutation SubAdmin_unassign($subAdminId: ID!, $unassignedReason: String!) {
  subAdmin_unassign(subAdminId: $subAdminId, unassignedReason: $unassignedReason) {
    code
    success
    error
    data {
      _id
      facilityManager {
        _id
        name
        email
      }
    }
  }
}
`;


 
export default function EditSubAdminButton(props) {
const subAdminId = props.id;
const [isShown, setIsShown] = React.useState(false)
const accesTokenValue = Cookies.get('userAccessToken');
const [dataObject, setDataObject] = useState({
    subAdminId:subAdminId,
});
const handleInputChange = (event) => {
    const { name, value } = event.target;
    let va = value
      setDataObject({
        ...dataObject,
        [name]: va
      });
    
  };
const [unAssignSubAdmin, { loading }] = useMutation(EDIT_SUBADMIN);

const handleSubmit=(e)=>{
    e.preventDefault()
  
    console.log(dataObject)
    
    unAssignSubAdmin({
      variables:dataObject,
      context: {
        headers: {
          Authorization: `Bearer ${accesTokenValue}`,
        },
      },
    })
    .then((response) => {
      toaster.success("Sub-admin un-assigned successfully.")
      setTimeout(()=>{
          window.location.reload()
      },1500)
    })
    .catch((error) => {
      toaster.danger(error.message)
    });
  }





    return (
        <div>
            <Dialog
            isShown={isShown}
            title="Edit Sub-Admin"
            onCloseComplete={() =>console.log("add")}
            onCancel={() => setIsShown(false)}
            shouldCloseOnOverlayClick={false}
            confirmLabel="Un-assign"
            onConfirm={handleSubmit}
            hasFooter={false}
            hasHeader={true}
            >
                <form onSubmit={handleSubmit}>
                    <div className='row'>
                        <div className='col s12 '>
                            <InputFieldTitleText>
                                Reason for un-assing
                            </InputFieldTitleText>
                            <AppInputField
                                type="text" 
                                placholder="alex iwobi"
                                name="unassignedReason" 
                                onChange={handleInputChange}
                            required/> 
                        </div>
                       
                       
                        
                        <div>
                            <div className='col s4 right mt-50' style={{
                                display:"flex",
                                flexWrap:"wrap",
                                justifyContent:"end"
                            }}>
                                <AppInputFieldBtn 
                                loading={loading}
                                className=''>
                                    Add
                                </AppInputFieldBtn>
                                
                            </div>
                            <div className='col s3 right' style={{
                                marginTop:"52px"
                            }}>
                                <AppInputFieldBtnCancel 
                                    onClick={()=>setIsShown(false)}
                                >
                                    Cancel
                                </AppInputFieldBtnCancel >
                            </div>
                        </div>
                    </div>
                </form>

                

            </Dialog>
            <FieldBtn onClick={() => setIsShown(true)} class="waves-effect waves-light btn-flat ">
                    <i class="material-icons left">edit</i>
                    Edit 
            </FieldBtn>

        </div>
        
    )
}




